import type { estypes } from '@elastic/elasticsearch'

export const commonAnalysis: estypes.IndicesIndexSettingsAnalysis = {
  tokenizer: {
    edge_ngram_tokenizer: {
      type: 'edge_ngram',
      //@ts-ignore
      min_gram: '1',
      //@ts-ignore
      max_gram: '20',
      token_chars: ['letter', 'digit'],
    },
    edge_ngram_tokenizer_whitespace: {
      type: 'edge_ngram',
      //@ts-ignore
      min_gram: '1',
      //@ts-ignore
      max_gram: '20',
      token_chars: ['letter', 'digit', 'punctuation', 'symbol'],
    },
  },
  filter: {
    english_stop: {
      type: 'stop',
      stopwords: '_english_',
    },
    english_stem: {
      type: 'stemmer',
      language: 'english',
    },
  },
  analyzer: {
    edge_ngram_analyzer_whitespace: {
      filter: ['lowercase'],
      type: 'custom',
      tokenizer: 'edge_ngram_tokenizer_whitespace',
    },
    edge_ngram_analyzer: {
      filter: ['lowercase'],
      type: 'custom',
      tokenizer: 'edge_ngram_tokenizer',
    },
    english_stop_and_stem: {
      type: 'custom',
      tokenizer: 'standard',
      filter: ['lowercase', 'english_stop', 'english_stem'],
    },
  },
}

export const textSubtypes = Object.freeze({
  fields: {
    edgeNgram: {
      type: 'text',
      analyzer: 'edge_ngram_analyzer',
      search_analyzer: 'standard',
    },
    edgeNgramWhitespace: {
      type: 'text',
      analyzer: 'edge_ngram_analyzer_whitespace',
      search_analyzer: 'keyword',
    },
    english: {
      type: 'text',
      analyzer: 'english_stop_and_stem',
    },
  },
} as { fields: Record<string, estypes.MappingProperty> })

export const commonMapping = {
  writerIds: {
    type: 'keyword',
    index: false,
  },
  lastEditedAt: {
    type: 'date',
    index: false,
  },
  lastEditedBy: {
    type: 'keyword',
    index: false,
  },
  updatedAt: {
    type: 'date',
    index: false,
  },
  title: {
    type: 'text',
    ...textSubtypes,
  },
  type: {
    type: 'keyword',
    index: false,
  },
  restrictedTo: {
    type: 'keyword',
    index: false,
  },
  reviewState: {
    type: 'keyword',
    index: false,
  },
  organizationId: {
    type: 'keyword',
    index: false,
  },
  parentNotesIdList: {
    type: 'keyword',
    index: false,
  },
  parentNotesTitleList: {
    type: 'keyword',
    index: false,
  },
  noteId: {
    type: 'keyword',
  },
  isTemplate: {
    type: 'boolean',
    index: false,
  },
  isCollectionRoot: {
    type: 'boolean',
    index: false,
  },
  isPubliclyShared: {
    type: 'boolean',
    index: false,
  },
  isChannelDoc: {
    type: 'boolean',
    index: false,
  },
  isArchived: {
    type: 'boolean',
    index: false,
  },
  iconShape: {
    type: 'keyword',
    index: false,
  },
  iconColor: {
    type: 'keyword',
    index: false,
  },
  iconVariant: {
    type: 'keyword',
    index: false,
  },
  fullPath: {
    type: 'text',
    ...textSubtypes,
  },
  createdAt: {
    type: 'date',
    index: false,
  },
  createdBy: {
    type: 'keyword',
    index: false,
  },
  ownerId: {
    type: 'keyword',
    index: false,
  },
  channelType: {
    type: 'keyword',
    index: false,
  },
  coverImageUrl: {
    type: 'keyword',
    index: false,
  },
  hasChildren: {
    type: 'boolean',
    index: false,
  },
  _tags: {
    type: 'keyword',
    index: false,
  },
  archivedAt: {
    type: 'date',
    index: false,
  },
  channelId: {
    type: 'keyword',
    index: false,
  },
  channelPurpose: {
    type: 'keyword',
    index: false,
  },
  titleWordsCount: {
    type: 'unsigned_long',
  },
  titleCharactersCount: {
    type: 'unsigned_long',
  },
  contentCharactersCount: {
    type: 'unsigned_long',
  },
  contentWordsCount: {
    type: 'unsigned_long',
  },
  mappingHash: { type: 'keyword' },
  indexedAt: {
    type: 'date',
  },
  externalType: {
    type: 'keyword',
    index: false,
  },
  externalUrl: {
    type: 'keyword',
    index: false,
  },
} satisfies Record<string, estypes.MappingProperty>
